import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const ProfileLazy = lazy(() => import('./ui/Profile'));

export const Profile = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <ProfileLazy />
    </Suspense>
  );
};
